import { UploadExternalData } from "../models";

export interface TooluploadState {
    data: UploadExternalData;
}


export const tooluploadInitialState: TooluploadState = {
    data: null
};
